const C_WHITE = "#ffffff";
const C_TEXT_DARK_PURPLE = "#302B63";
const C_TEXT_MID_DARK_GREY = "#575757";
const C_TABLE_HEADER_ROW = "#302B63";

// Responsive so the extra description column stays readable on smaller screens.
const FONT_SIZE = { xs: "1.1rem", sm: "1.25rem", md: "1.4rem" };
const CELL_TOP_BOTTOM_PADDING = "14px";
const CELL_BIGGER_TOP_BOTTOM_PADDING = "20px";
const CELL_LEFT_RIGHT_PADDING = { xs: "6px", sm: "10px", md: "14px" };

export const materialsStyles = {
  container: {
    width: "90%",
    margin: "auto",
    marginTop: "3%",
    marginBottom: "3%",
    // Wide table scrolls horizontally instead of overflowing narrow viewports.
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  },

  table: {
    paddingLeft: 20,
    paddingRight: 20,
    minWidth: 720,
  },

  tableHeadRow: {
    backgroundColor: C_TABLE_HEADER_ROW,
  },

  tableHeadCell: {
    fontSize: FONT_SIZE,
    color: C_WHITE,
    textAlign: "center",
    paddingTop: CELL_BIGGER_TOP_BOTTOM_PADDING,
    paddingBottom: CELL_BIGGER_TOP_BOTTOM_PADDING,
    paddingLeft: CELL_LEFT_RIGHT_PADDING,
    paddingRight: CELL_LEFT_RIGHT_PADDING,
  },

  sortLabel: {
    color: C_WHITE,
    fontSize: FONT_SIZE,
    "&:hover": {
      color: C_WHITE,
    },
    "&.Mui-active": {
      color: C_WHITE,
    },
    "& .MuiTableSortLabel-icon": {
      color: C_WHITE,
      opacity: 0.5,
    },
    "&.Mui-active .MuiTableSortLabel-icon": {
      color: C_WHITE,
      opacity: 1,
    },
  },

  tableBodyCellRowNumber: {
    paddingTop: CELL_TOP_BOTTOM_PADDING,
    paddingBottom: CELL_TOP_BOTTOM_PADDING,
    paddingLeft: CELL_LEFT_RIGHT_PADDING,
    width: "30px",
  },

  tableBodyCell: {
    textAlign: "center",
    paddingTop: CELL_TOP_BOTTOM_PADDING,
    paddingBottom: CELL_TOP_BOTTOM_PADDING,
    paddingLeft: CELL_LEFT_RIGHT_PADDING,
    paddingRight: CELL_LEFT_RIGHT_PADDING,
  },

  // Descriptive article text: capped width + wrapping so long values do not
  // stretch the table, left-aligned for readability of multi-line text.
  descriptionCell: {
    textAlign: "left",
    verticalAlign: "top",
    paddingTop: CELL_TOP_BOTTOM_PADDING,
    paddingBottom: CELL_TOP_BOTTOM_PADDING,
    paddingLeft: CELL_LEFT_RIGHT_PADDING,
    paddingRight: CELL_LEFT_RIGHT_PADDING,
    minWidth: { xs: 140, sm: 180, md: 220 },
    maxWidth: { xs: 180, sm: 240, md: 320 },
  },

  descriptionText: {
    fontSize: FONT_SIZE,
    color: C_TEXT_MID_DARK_GREY,
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  },

  materialName: {
    fontSize: FONT_SIZE,
    fontWeight: "bold",
    color: C_TEXT_DARK_PURPLE,
  },

  rowNr: {
    fontSize: FONT_SIZE,
    color: C_TEXT_MID_DARK_GREY,
    alignSelf: "center",
    textAlign: "center",
  },

  noMaterials: {
    textAlign: "center",
  },

  statusBox: {
    textAlign: "center",
    marginTop: "10%",
  },
};
